<div fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row">
    <h3>Pola do zmiany</h3>
  </div>

  <div fxLayout="row">
    <mat-selection-list
      fxFlex="100" [formControl]="fieldsControl" fxLayout="row wrap"
    >
      <mat-list-option fxFlex="48" checkboxPosition="before" [value]="'internalRisk'">Ryzyko ASF</mat-list-option>
      <mat-list-option fxFlex="48" checkboxPosition="before" [value]="'riskPack'">Kod grupy</mat-list-option>
      <mat-list-option fxFlex="48" checkboxPosition="before" [value]="'policyType'">Typ polisy</mat-list-option>
      <mat-list-option fxFlex="48" checkboxPosition="before" [value]="'ofwca'">OFWCA</mat-list-option>
      <mat-list-option fxFlex="48" checkboxPosition="before" [value]="'ratePaid'">Stawka % Partner</mat-list-option>
      <mat-list-option fxFlex="48" checkboxPosition="before" [value]="'status'">Status</mat-list-option>
      <mat-list-option fxFlex="48" checkboxPosition="before" [value]="'commissionPaid'">Prowizja zł Partnera</mat-list-option>
      <mat-list-option [disabled]="!block" fxFlex="48" checkboxPosition="before" [value]="'block'">Blokada zmian na polisach</mat-list-option>
      <mat-list-option *ngIf="(userPermissions | async).settlement.admin_root" fxFlex="48" checkboxPosition="before" [value]="'contract'">Umowa</mat-list-option>

    </mat-selection-list>
  </div>

  <div fxLayout="row" *ngIf="fieldsControl.value?.includes('internalRisk')">
    <app-dict
      fxFlex="100"
      [multiple]="false" label="Ryzyko ASF"
      dictType="internal_risk"
      [formControl]="internalRiskControl"
    ></app-dict>
  </div>

  <div fxLayout="row" *ngIf="fieldsControl.value?.includes('riskPack')">
    <mat-form-field fxFlex="100">
      <mat-label>Kod grupy</mat-label>
      <input matInput placeholder="Kod grupy" [formControl]="riskPackControl">
    </mat-form-field>
  </div>

  <div fxLayout="row" *ngIf="fieldsControl.value?.includes('policyType')">
    <app-dict
      fxFlex="100"
      [multiple]="false" label="Typ polisy"
      dictType="sold_policy_type"
      [formControl]="policyTypeControl"
    ></app-dict>
  </div>

  <div fxLayout="row" *ngIf="fieldsControl.value?.includes('ofwca')">
    <app-dict-ofwcas
      fxFlex="100"
      [required]="false"
      [multiple]="false" label="OFWCA"
      [control]="ofwcaControl"
    ></app-dict-ofwcas>
  </div>
  <div fxLayout="row" *ngIf="noContract">
  <mat-error class="noContract">Wybrana OFWCA nie jest powiązana z żadną aktywną umową</mat-error>
  </div>

  <div fxLayout="row" *ngIf="fieldsControl.value?.includes('ratePaid')">
    <mat-form-field fxFlex="100">
      <mat-label>Stawka % Partner</mat-label>
      <input matInput placeholder="Stawka % Partner" [formControl]="ratePaidControl">
    </mat-form-field>
  </div>
  <div fxLayout="row" *ngIf="fieldsControl.value?.includes('commissionPaid')">
    <mat-form-field fxFlex="100">
      <mat-label>Prowizja zł Partnera</mat-label>
      <input matInput placeholder="Prowizja zł Partnera" [formControl]="commissionPaidControl">
    </mat-form-field>
  </div>

  <div fxLayout="column"  fxLayoutGap="15px" *ngIf="fieldsControl.value?.includes('status')">
    <mat-slide-toggle fxFlex="100" color="accent" [formControl]="rejectedControl" >Rekord odrzucony</mat-slide-toggle>
    <mat-slide-toggle fxFlex="100" color="accent" [formControl]="assignedControl" >Rekord przypisany</mat-slide-toggle>
  </div>
  <div fxLayout="column"  fxLayoutGap="15px" *ngIf="fieldsControl.value?.includes('contract')">
        <app-dict-all-contracts
          fxFlex="100" label="Umowa"
          [control]="contractControl"
          [required]="true"
          [filterPartnership]="false"
          [showElements]="4"
          [partnershipContracts] = "true"
        ></app-dict-all-contracts>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" >
    <button (click)="sendForm()" [disabled]="processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
